<template>
  <div class="drawer-detail">
    <div class="field-type">
      <span class="label">
        职能模块认知:
        <el-tooltip :disabled="!showLogs||showLogs.length===0" :visible-arrow="false" popper-class="alpha-color-ccc" effect="light" placement="left">
          <div slot="content" style="max-height:300px;width:300px;overflow:auto;">
            <div
              v-for="item in showLogs"
              :key="item.createdAt"
              class="edit-dialog-single-p"
              style="flex-wrap:wrap"
            >
              <b style="color:#BCBCBC"
                >{{ dateFormat(item.createdAt) }} -- {{ item.account
                }}<span class="cate-tag">{{ activeCategory.职能模块 }}</span>
              </b>
              <span style="display:block;width:100%;margin-top:10px;margin-bottom: 10px;white-space:pre-wrap;color:#333;"><i class="el-icon-info"></i> {{ item.content }}</span>
              <!-- <div style="display:flex;width: 100%;align-items: flex-start;margin-top:10px;">
                <i class="el-icon-info mr10" style="flex:none"></i><span style="flex:auto;display: inline-block;white-space: pre-wrap;word-break: break-word;">{{ item.content }}</span>
              </div> -->
          </div>
          </div>
          <span :class="!showLogs||showLogs.length===0?'shallow-gray-text':'link-text'"><i class="el-icon-view mr10"></i>职能模块认知备注</span>
        </el-tooltip>
      </span>
      <span
        v-for="item in company.职能模块认知"
        :key="item._id"
        :class="{ 'type-tag': true, active: activeCategory._id === item._id }"
        size="small"
        @click="activeCategory = item"
      >
        {{ item.职能模块 }}
      </span>
    </div>
    <div class="field-type">
      <div :class="[activeCategory.职能模块认知?'':'gray-text','value company-pre']">
        <p v-if="activeCategory.职能模块认知">{{activeCategory.职能模块认知}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['职能模块认知'],
      activeCategory:{},
    }
  },
  computed: {
    showLogs() {
      const logs = window._.cloneDeep(this.activeCategory.logs || [])
      logs.sort((a, b) => b.createdAt - a.createdAt)
      return logs
    },
  },
  watch: {
    company: {
      handler(newValue, oldValue) {
        this.init()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    init(){
      if(Object.keys(this.activeCategory).length===0&&this.company.职能模块认知&&this.company.职能模块认知.length>0){
        this.activeCategory = this.company.职能模块认知[0]
      }
    },
    dateFormat(val, type) {
      return val ? dateFormat(val, type || 'yyyy-mm-dd') : ''
    },
    quickEdit(){
      const { activeCategory } = this
      const cloneActiveCategory = window._.cloneDeep(activeCategory)
      this.$emit('quickEdit',{
        value: cloneActiveCategory.职能模块认知,
        label: activeCategory.职能模块,
        type:'input',
        confirmFunc:async(v)=>{
          cloneActiveCategory.职能模块认知 = v
          const toupdate = [cloneActiveCategory]
          const option = { toupdate }
          const res = await app.service('company').modifyComCateCognition({
            cid: this.company._id,
            option: option,
          })
          if (res.status === 'success') {
            this.$set(this.activeCategory,'职能模块认知',v)
            this.$message.success(`修改成功`)
          }
        },
      })
    },
  },
}
</script>
<style>
.alpha-color-ccc{
  border-color:#CCCCCC!important;
  box-shadow: 0 0 5px 0px #d0d0d0;
}
</style>
<style scoped>
.flex {
  display: flex;
}
/* .cate-item{
  display: inline-block;
  cursor: pointer;
  margin: 0 8px 6px 0;
  padding: 4px 12px;
  border-radius: 2px;
  min-width: 76px;
  text-align: center;
  color:#fff;
  background-color: #2478b5;
}
.cate-item.active{
  background-color: #4B7A90;
} */
.type-tag {
  padding: 6px 10px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border: 1px solid #2478b5;
  color: #467388;
  display: inline-block;
  margin-right: -1px;
  border-bottom: 0;
  cursor: pointer;
}
.type-tag.active {
  color: #fff;
  background-color: #8DB9CE;
  border-color: #8DB9CE;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
